export default "__VITE_ASSET__CLDTqQuk__"